import { useCallback } from 'react';
import { useCableSubscription } from './useCableSubscription';
import { useDeleteMemoFromCache } from 'hooks/memos/mutations';
import { isCurrentSession } from 'utils/SessionIDUtil';

/**
 * MemoCable component for handling memo-related cable events
 */
function MemoCable({ projectId }) {
  const deleteMemoFromCache = useDeleteMemoFromCache();

  const handleMemoCable = useCallback((response) => {
    // Skip processing if this response is from the current session
    if (response.session_id && isCurrentSession(response.session_id)) {
      return;
    }

    if (response['action'] === 'destroy') {
      if (response.memo_id && response.id) {
        deleteMemoFromCache.mutate({
          memoId: response.memo_id,
          excerptId: response.excerpt_id
        });
      }
    }
  }, [deleteMemoFromCache]);

  useCableSubscription({
    channel: { channel: 'MemosChannel', project: projectId },
    onReceived: handleMemoCable
  });

  return null;
}

export default MemoCable;
